// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {Icon, Space, Styled} from '@supermove/components';
import {useResponsive} from '@supermove/hooks';

// App
import Button from '@shared/design/components/Button';
import SecondaryButton from '@shared/design/components/Button/SecondaryButton';
import InviteMoverStep from '@shared/modules/User/enums/InviteMoverStep';
import MoverForm from '@shared/modules/User/forms/MoverForm';

const Row = Styled.View`
  flex-direction: row;
`;

const PrimaryActionButton = ({
  canSubmitStep,
  nextStepKind,
  currentStepKind,
  form,
  setCurrentStepKind,
  handleSubmit,
  submitting,
  setCompletedSteps,
  isWidthOfContainer,
}: {
  canSubmitStep: boolean;
  nextStepKind: string | null;
  currentStepKind: string;
  form: any;
  setCurrentStepKind: (value: string | ((prevVar: string) => string)) => void;
  handleSubmit: () => void;
  submitting: boolean;
  setCompletedSteps: (value: string[] | ((prevVar: string[]) => string[])) => void;
  isWidthOfContainer: boolean;
}) => {
  return (
    <Button
      text={
        canSubmitStep
          ? 'Submit'
          : nextStepKind
            ? `Next: ${InviteMoverStep.getStep(nextStepKind).title}`
            : 'Next'
      }
      onPress={async () => {
        const errors = await MoverForm.validateStep({stepKind: currentStepKind, form});

        if (!_.isEmpty(errors)) {
          return;
        }

        setCompletedSteps((prevItems: string[]) => _.union(prevItems, [currentStepKind]));

        if (canSubmitStep) {
          handleSubmit();
          return;
        }

        if (nextStepKind) {
          setCurrentStepKind(nextStepKind);
        }
      }}
      isSubmitting={submitting}
      iconLeft={canSubmitStep ? Icon.Check : undefined}
      iconRight={canSubmitStep ? undefined : Icon.ArrowRight}
      iconSize={12}
      isWidthOfContainer={isWidthOfContainer}
      style={{width: isWidthOfContainer ? '100%' : 248}}
      isResponsive
    />
  );
};

const InviteMoverModalFooter = ({
  isViewingFirstStep,
  previousStepKind,
  nextStepKind,
  currentStepKind,
  setCurrentStepKind,
  setCompletedSteps,
  form,
  isReviewingSteps,
  handleSubmit,
  submitting,
}: {
  isViewingFirstStep: boolean;
  previousStepKind: string | null;
  nextStepKind: string | null;
  currentStepKind: string;
  setCurrentStepKind: (value: string | ((prevVar: string) => string)) => void;
  setCompletedSteps: (value: string[] | ((prevVar: string[]) => string[])) => void;
  form: any;
  isReviewingSteps: boolean;
  handleSubmit: () => void;
  submitting: boolean;
}) => {
  const responsive = useResponsive();
  const canSubmitStep = currentStepKind === 'REVIEW';

  return (
    <React.Fragment>
      {responsive.desktop && (
        <React.Fragment>
          {!isViewingFirstStep && (
            <SecondaryButton
              text={'Back'}
              onPress={() => {
                if (previousStepKind) {
                  setCurrentStepKind(previousStepKind);
                }
              }}
              iconLeft={Icon.ArrowLeft}
              iconSize={12}
            />
          )}
          <Space style={{flex: 1}} />
        </React.Fragment>
      )}
      {isReviewingSteps && currentStepKind !== 'REVIEW' ? (
        <Button
          text={'Return to Review'}
          onPress={async () => {
            const errors = await MoverForm.validateStep({
              stepKind: currentStepKind,
              form,
            });

            if (!_.isEmpty(errors)) {
              return;
            }

            setCurrentStepKind('REVIEW');
          }}
          iconRight={Icon.ArrowRight}
          iconSize={12}
          isWidthOfContainer={!responsive.desktop}
          style={responsive.desktop ? {} : {width: '100%'}}
          isResponsive
        />
      ) : (
        <PrimaryActionButton
          canSubmitStep={canSubmitStep}
          nextStepKind={nextStepKind}
          currentStepKind={currentStepKind}
          form={form}
          setCurrentStepKind={setCurrentStepKind}
          handleSubmit={handleSubmit}
          submitting={submitting}
          setCompletedSteps={setCompletedSteps}
          isWidthOfContainer={!responsive.desktop}
        />
      )}
    </React.Fragment>
  );
};

export default InviteMoverModalFooter;
